import router from '@/router'

export default {
    namespaced: true, 
    state: {
        isAdmin: false,
        isApply: false,
        isLogin: false,
        isMain : false,
        isApprovedStandard : false,
        isOrgApprovedStandard : false,
        isDistributionStatus : false,
        isGiasStatus : false,
        isPassWordUpdate : false,
        isMsgDetailPopup : false,
        searchParam : {
            pageNo : 1,
            pageSize : 10,
            countPerRecord : 10,
            searchText : ''
        },
        searchParamForApply : {
            pageNo : 1,
            search : ''
        },
        userInfo: {
            userId: '',              // user_id AS userId
            userName: '',            // user_name AS userName
            email: '',               // email AS email
            userType: '',            // user_type AS userType
            corporateId: '',         // corporate_id AS corporateId
            planId: '',              // plan_id AS planId
            status: '',              // status AS status
            createdAt: '',           // created_at AS createdAt
            updatedAt: '',           // updated_at AS updatedAt
            phone: '',               // phone AS phone
            orgName: '',             // org_name AS orgName
            position: '',            // position AS position
            orgPhone: '',            // org_phone AS orgPhone
            zoneCode: '',            // zone_code AS zoneCode
            address: '',             // address AS address
            extraAddress: '',        // extra_address AS extraAddress
            detailAddress: '',       // detail_address AS detailAddress
            gender: ''               // gender AS gender
        },

        main : {}
    },
    mutations: {
        setIsAdmin(state, payload) {
            state.isAdmin = payload
        },
        setIsApply(state, payload) {
            state.isApply = payload
        },
        setIsLogin(state, payload) {
            state.isLogin = payload
        },
        setIsMain(state, payload){
            state.isMain = payload
        },
        setIsApprovedStandard(state) {
            state.isApprovedStandard = !state.isApprovedStandard
        },
        setIsOrgApprovedStandard(state) {
            state.isOrgApprovedStandard = !state.isOrgApprovedStandard
        },
        setIsDistributionStatus(state) {
            state.isDistributionStatus = !state.isDistributionStatus
        },
        setIsGiasStatus(state) {
            state.isGiasStatus = !state.isGiasStatus
        },
        setIsPassWordUpdate(state) {
            state.isPassWordUpdate = !state.isPassWordUpdate
        },
        setIsMsgDetailPopup(state) {
            state.isMsgDetailPopup = !state.isMsgDetailPopup
        },
        setIsChipFalse(state) {
            state.isChip = false
        },
        setSearchParam(state, payload) {
            state.searchParam[payload.key] = payload.value
        },
        setUserInfo(state, payload) {
            state.userInfo[payload.key] = payload.value
        },
        setMainData(state, payload) {
            state.main = payload
        },
        clearSearchParam (state) {
            state.searchParam = {}
            state.searchParam.pageNo = 1
            state.searchParam.search = ''
        },
        clearUserInfo(state) {
            state.userInfo = {
                usersCode : '',
                userId : '',
                organizationsCode : '',
                departmentsCode : "",
                departmentsName : '',
                name : '',
                role : ''
            }
        },       
        clearMainData(state) {
            state.main = {}
        },
        setSearchParamForApply(state, payload) {
            state.searchParamForApply[payload.key] = payload.value
        },
        clearSearchParamForApply (state) {
            state.searchParamForApply.pageNo = 1
            state.searchParamForApply.search = ''
        },
    },
    actions : {
        async clearSessionOut ({state, commit}) {
            //delCookie("sessionId")
            commit('setIsLogin', false)
            commit('setIsAdmin', false)
            commit('clearUserInfo')
			router.push({name:'Home'})
        },
    }, 
    clearTemp(state) {
        state.isApprovedStandard = false
        state.isOrgApprovedStandard = false
        state.isDistributionStatus = false
        state.isGiasStatus = false
        state.isPassWordUpdate = false
        state.isMsgDetailPopup = false
    }

}